import React from "react";
import { SnackbarContent, SnackbarContentProps } from "notistack";
import {
  Card,
  CardActions,
  CardActionsProps,
  CardProps,
  IconButton,
  IconButtonProps,
  Paper,
  PaperProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import styled from "@emotion/styled";

export const StyledSnackBarContent: React.FC<SnackbarContentProps & React.RefAttributes<any>> = styled(SnackbarContent)`
  min-width: 1000px !important;
  max-width: 1200px;
`;

export const StyledCard: React.FC<CardProps> = styled(Card)`
  background-color: #f44336;
  width: 100%;
`;

export const StyledCardActions: React.FC<CardActionsProps> = styled(CardActions)`
  padding: 8px 8px 8px 16px;
  justify-content: space-between;
`;

export const StyledTypographyBoldWhite: React.FC<TypographyProps> = styled(Typography)`
  font-weight: bold;
  color: white;
`;

export const TitleContainer: React.FC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ErrorIconContainer: React.FC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  color: white;
`;

export const CardActionIconsContainer: React.FC = styled.div`
  margin-left: auto;
`;

export const StyledIconButton: React.FC<IconButtonProps & { expanded: boolean }> = styled(IconButton, {
  shouldForwardProp: (prop) => !["expanded"].includes(prop),
})(({ expanded }: IconButtonProps & { expanded: boolean }) => {
  return {
    padding: "8px 8px",
    transform: expanded ? "rotate(0deg)" : "rotate(180deg)",
  };
}) as React.FC<IconButtonProps & { expanded: boolean }>;

export const StyledPaper: React.FC<PaperProps> = styled(Paper)`
  padding: 16px;
`;

export const StyledTypography: React.FC<TypographyProps> = styled(Typography)`
  white-space: pre-line;
`;

export const StyledRequestIdDiv: React.FC = styled.div`
  margin-top: 20px;

  > * {
    font-size: smaller;
    color: darkgrey;
  }
`;
